import React from "react";

import { cn } from "../../../lib/utils";
import { Switch } from "../../ui/switch";

interface EDSThemeToggleProps {
  isDarkMode: boolean;
  onToggle: (isDarkMode: boolean) => void;
  className?: string;
}

const EDSThemeToggle: React.FC<EDSThemeToggleProps> = ({
  isDarkMode,
  onToggle,
  className = ""
}) => {
  const handleToggle = (checked: boolean) => {
    // When switch is checked (right side), it should be dark mode
    // When switch is unchecked (left side), it should be light mode
    onToggle(checked);
  };

  return (
    <div className={cn("eds-theme-toggle", className)}>
      <Switch
        checked={isDarkMode}
        onCheckedChange={handleToggle}
        className="eds-theme-toggle__switch"
        aria-label="Toggle theme"
        aria-checked={isDarkMode}
        role="switch"
      />
    </div>
  );
};

export default EDSThemeToggle;
